import { Link } from 'react-router';
import type { MenuItem } from 'types/capi/plp';

import gtm from '~/services/gtm.client';

type Props = {
  options: MenuItem[];
};

const FilterOptions = ({ options }: Props) => {
  const defaultClasses =
    'rounded-full border border-grey-hide text-grey-hide text-sm md:py-2';
  const selectedClasses = 'bg-black text-white border-none py-1';

  function onClick(filterName: string, value: string) {
    gtm.sendPlpProductFilterEvent({
      filterName,
      filterValue: value,
      pagePosition: 'Top Bar'
    });
  }

  return (
    <div className="flex w-full justify-center gap-2 md:w-[264px] md:justify-end">
      {options.map((item) => {
        return (
          <Link
            onClick={() => onClick(item.text, item.text)}
            rel="nofollow"
            to={item.path}
            className={`flex h-8 w-full items-center justify-center md:h-10 md:max-w-24 ${defaultClasses} ${
              item.active ? selectedClasses : ''
            }`}
            key={item.path}
          >
            {item.text}
          </Link>
        );
      })}
    </div>
  );
};

export default FilterOptions;
